import { graphql } from "@opensea/graphql"
import { ProfileAddressChipFragment } from "./chips/ProfileAddressChip"
import { ProfileBetaTesterChipFragment } from "./chips/ProfileBetaTesterChip"
import { ProfileCoinbaseOneChipFragment } from "./chips/ProfileCoinbaseOneChip"
import { ProfileENSChipFragment } from "./chips/ProfileENSChip"
import { ProfileIsStaffChipFragment } from "./chips/ProfileIsStaffChip"
import { ProfileJoinedAtChipFragment } from "./chips/ProfileJoinedAtChip"

export const ProfileMetadataChipFragment = graphql(
  `
    fragment ProfileMetadataChip on Profile {
      ...ProfileENSChip
      ...ProfileAddressChip
      ...ProfileJoinedAtChip
      ...ProfileBetaTesterChip
      ...ProfileCoinbaseOneChip
      ...ProfileIsStaffChip
      address
    }
  `,
  [
    ProfileENSChipFragment,
    ProfileAddressChipFragment,
    ProfileJoinedAtChipFragment,
    ProfileBetaTesterChipFragment,
    ProfileCoinbaseOneChipFragment,
    ProfileIsStaffChipFragment,
  ],
)
